import { trackFeatureUsage } from "@/utils/gtm";

export type OnboardingAnalyticsAction =
  | "started"
  | "step_completed"
  | "skipped"
  | "resumed"
  | "template_applied"
  | "watchlists_selected"
  | "concierge_requested"
  | "concierge_applied"
  | "checklist_opened"
  | "checklist_task_done"
  | "checklist_dismissed";

/**
 * Onboarding funnel events, routed through the existing GA4 feature_usage
 * event so they land in the same GTM container with user props attached.
 */
export function trackOnboarding(
  action: OnboardingAnalyticsAction,
  detail?: string
) {
  trackFeatureUsage({
    feature_name: "onboarding",
    feature_action: action,
    ...(detail && { feature_detail: detail }),
  });
}
